import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import PurchaseForm from './PurchaseForm';

export class PurchaseUpdateForm extends FormView {
    protected getFormComponent() {
        return PurchaseForm;
    }
}

export default PurchaseUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(PurchaseUpdateForm));
